import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { ModelConstants } from 'shell-models-lib';
import { ApiIntegrationActivity } from './api-integration.activity';

@Metamodel.model({
    name: ModelConstants.fabricActionsActivity,
    referable: true
})
export class FabricActionsActivity extends ApiIntegrationActivity {
    public static readonly MODEL: IModel;
}
